var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ReviewScore row"},[_c('div',{staticClass:"ml-1"},_vm._l((_vm.count),function(star){return _c('va-icon',{key:star,attrs:{"color":"warning","name":"fa fa-star"}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }